import { styled } from '@mui/material/styles'

export const ShellContent = styled('main')({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  minWidth: 0,
  minHeight: 0,
  overflow: 'hidden'
})

export const AppViewport = styled('div')({
  flex: 1,
  minHeight: 0,
  overflow: 'auto'
})
